import { useMemo } from "react";
import { countryToAlpha2 } from "country-to-iso";
import ReactCountriesFlags from "react-countries-flags";
import { Flex, Text } from "@jsq/ds/core";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { DomicileVariant } from "./constants";
import { tableStyle, caseDetailsHeaderStyle, flagMarginStyle } from "./styles_vanilla.css";

interface Props {
  params: AGGridCellRenderParams | { value: string | null };
  variant?: DomicileVariant;
}

export const DomicileRenderer = ({
  params: { value: countryName },
  variant = "compact",
}: Props) => {
  const countryCode = useMemo(
    () => (typeof countryName === "string" ? countryToAlpha2(countryName) : null),
    [countryName],
  );
  const isHeaderVariant = variant === "header";
  return (
    <Flex
      className={isHeaderVariant ? caseDetailsHeaderStyle : tableStyle}
      alignItems="center"
      gap={4}
    >
      {countryCode && (
        <div className={isHeaderVariant ? undefined : flagMarginStyle}>
          <ReactCountriesFlags
            data-cy="domicile-country-flag"
            isoCode={countryCode}
            alt={`${countryCode} flag`}
          />
        </div>
      )}
      <Text
        data-testid="domicile"
        data-cy="domicile"
        marginBottom={isHeaderVariant ? undefined : "xs"}
      >
        {countryName}
      </Text>
    </Flex>
  );
};
